import type { DialogProps, DialogSize } from "./Dialog";
import { Dialog } from "./Dialog";

export { Dialog };
export type { DialogProps, DialogSize };
